import { useResource } from "hooks/useResource";
import { getStats } from "services/content";
import CountUp from "components/shared/CountUp";
import Skeleton from "components/shared/Skeleton";

export default function StatsBar() {
  const { data: stats, loading } = useResource(getStats);

  return (
    <div className="bg-green-dark px-4 sm:px-10 py-[26px]">
      <div className="max-w-container mx-auto grid grid-cols-2 md:grid-cols-4 gap-4">
        {loading || !stats
          ? Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="text-center flex flex-col items-center gap-2">
                <Skeleton dark className="h-9 w-24" />
                <Skeleton dark className="h-3 w-28" />
              </div>
            ))
          : stats.map(({ value, label }) => (
              <div key={label} className="text-center">
                <CountUp
                  value={value}
                  className="block font-serif text-[30px] sm:text-[38px] font-bold text-gold-light leading-[1.1]"
                />
                <div className="text-[#8ec4b0] text-[12px] sm:text-[13px] mt-1">
                  {label}
                </div>
              </div>
            ))}
      </div>
    </div>
  );
}
